import { render, staticRenderFns } from "./Tree-Nested-Selector-Legacy.vue?vue&type=template&id=98e3a738&lang=pug"
import script from "./Tree-Nested-Selector-Legacy.vue?vue&type=script&lang=ts"
export * from "./Tree-Nested-Selector-Legacy.vue?vue&type=script&lang=ts"
import style0 from "./Tree-Nested-Selector-Legacy.vue?vue&type=style&index=0&id=98e3a738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports